// Revenue triage — sticky bottom bulk-action bar shared by Income and
// Expenses. Appears when a selection exists; the owning tab supplies the
// action buttons as children so each ledger keeps its own mutations.
// Keeps data-testid="bulk-action-bar" (pinned by existing suites).

import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export function BulkBar({
  count,
  totalMatching,
  onSelectAllMatching,
  onClear,
  children,
}: {
  /** Selected row count; the bar renders nothing at 0. */
  count: number;
  /** Rows matching the current filters — powers "Select all N". */
  totalMatching: number;
  onSelectAllMatching: () => void;
  onClear: () => void;
  children: React.ReactNode;
}) {
  if (count === 0) return null;
  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-3 py-2 shadow-lg max-w-[95vw] overflow-x-auto"
      data-testid="bulk-action-bar"
    >
      <span className="text-sm font-medium text-gray-900 whitespace-nowrap" data-testid="text-bulk-count">
        {count} selected
      </span>
      {count < totalMatching && (
        <Button
          variant="ghost"
          size="sm"
          className="px-1 whitespace-nowrap text-brand underline-offset-2 hover:underline"
          onClick={onSelectAllMatching}
          data-testid="button-select-all-matching"
        >
          Select all {totalMatching}
        </Button>
      )}
      <span className="h-5 w-px bg-gray-200 shrink-0" aria-hidden="true" />
      {children}
      <span className="h-5 w-px bg-gray-200 shrink-0" aria-hidden="true" />
      <Button
        variant="ghost"
        size="sm"
        onClick={onClear}
        aria-label="Clear selection"
        data-testid="button-bulk-clear"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
